import { Emitter, Event } from "../../../../features/event-emitter"
import { fileHelpers } from "../../../../features/files"
import { firstItem } from "../../../../utils/listUtils"
import { useExpenseLoaders } from "../../loaders/expenseLoaders"
import { useTicketLoaders } from "../../loaders/ticketLoaders"
import { useTicketService } from "../../services/ticketService"
import { Ticket } from "../../state/types"

export const useActions = () => {
    const { expenseTicketSubPath, getFileExtension } = fileHelpers

    const expenseLoaders = useExpenseLoaders()
    const ticketLoaders = useTicketLoaders()
    
    const { uploadTicketFile } = useTicketService()

    const submitTicket = async (
        expenseId: string,
        ticketFile: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { loadExpense } = expenseLoaders()
        const loadedExpense = await loadExpense(expenseId)

        const { loadParentTickets } = ticketLoaders()
        const loadedTickets = await loadParentTickets(expenseId)
        const loadedTicket = firstItem(loadedTickets)!
        
        const ext = getFileExtension(ticketFile)
        const fileSubPath = (ticket: Ticket) => expenseTicketSubPath(ticket, loadedExpense!.code, ext)
        const savedTicket = await uploadTicketFile(loadedTicket.id, fileSubPath, ticketFile)

        Emitter.emit(Event.DB_SUBMIT_DONE, false, false)

        return savedTicket
    }
    
    return {
        submitTicket
    }
}
